export default {
  title: 'Improve <strong>{purpose}</strong>',
  title_add: 'Improve <strong>{purpose}</strong> and <strong>{addPurpose}</strong>',
  date: 'by {dates}',
  reviewTitle: 'Customer reviews'
}
